import { Navigate, useParams } from 'react-router-dom';
import { useAuthAppContext } from '../../context/useAuthAppContext';
import { AppRoutes } from '../../types/appRoutes';
import AdminLayout from './component/adminLayout';
import { AdminTabEnum, getAdminTab, isValidAdminTab } from './component/admin.constants';

const AdminPage = () => {
  const { isAuthenticated } = useAuthAppContext();
  const { tab } = useParams();

  if (isAuthenticated) {
    if (tab !== undefined && !isValidAdminTab(tab)) {
      return <Navigate to={AppRoutes.routeAdmin} replace />;
    }
    const selectedTab: AdminTabEnum | undefined = getAdminTab(tab);

    return <AdminLayout selectedTab={selectedTab} />;
  }

  return <Navigate to={AppRoutes.routeErrorPage} replace />;
};

export default AdminPage;
